import { Col, Input, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import styled from 'styled-components';

const TierContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: ${theme.GREY_10};
  border-radius: 8px;
  margin-bottom: 12px;
`;

const TierHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const TierBadge = styled.span`
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  margin-right: 12px;
  background: ${(props) => {
    if (props.tier === 'gold') return '#FFD70030';
    if (props.tier === 'silver') return '#C0C0C030';
    return '#CD7F3230';
  }};
  color: ${(props) => {
    if (props.tier === 'gold') return '#B8860B';
    if (props.tier === 'silver') return '#808080';
    return '#8B4513';
  }};
`;

const TierEmoji = styled.span`
  font-size: 20px;
  margin-right: 8px;
`;

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-right: 8px;
`;

const TIER_CONFIG = {
  bronze: { emoji: '🥉', label: 'Bronze' },
  silver: { emoji: '🥈', label: 'Silver' },
  gold: { emoji: '🥇', label: 'Gold' }
};

const TierEligibility = ({ tier, value, onChange }) => {
  const config = TIER_CONFIG[tier];

  const handleChange = (field, val) => {
    onChange({
      ...value,
      [field]: val
    });
  };

  return (
    <TierContainer>
      <TierHeader>
        <TierEmoji>{config.emoji}</TierEmoji>
        <TierBadge tier={tier}>{config.label}</TierBadge>

        <Row noFlex center style={{ marginLeft: 'auto' }}>
          <Checkbox
            type="checkbox"
            checked={value.eligible}
            onChange={(e) => handleChange('eligible', e.target.checked)}
          />
          <Text b2>Eligible</Text>
        </Row>
      </TierHeader>

      {value.eligible && (
        <Col gap="12px">
          <Row start gap="16px">
            <Col wid="120px">
              <Input
                title="Slots"
                type="number"
                min="0"
                value={value.slots || 0}
                onChange={(e) => handleChange('slots', parseInt(e.target.value) || 0)}
                placeholder="0"
              />
            </Col>
            <Col wid="100%">
              <Input
                title="Description"
                value={value.description || ''}
                onChange={(e) => handleChange('description', e.target.value)}
                placeholder={`Description for ${config.label} tier...`}
              />
            </Col>
          </Row>
          <Row start gap="16px">
            <Col wid="100%">
              <Input
                title="Description (Japanese)"
                value={value.descriptionJa || ''}
                onChange={(e) => handleChange('descriptionJa', e.target.value)}
                placeholder={`${config.label} 用の説明...`}
              />
            </Col>
          </Row>
        </Col>
      )}
    </TierContainer>
  );
};

const EligibilitySection = ({ value, onChange }) => {
  const handleTierChange = (tier, tierValue) => {
    onChange({
      ...value,
      [tier]: tierValue
    });
  };

  return (
    <Col wid="100%">
      <Text b2 med marg="0 0 12px">
        Eligibility by Tier
      </Text>

      <TierEligibility
        tier="bronze"
        value={value.bronze || { eligible: true, slots: 0, description: '', descriptionJa: '' }}
        onChange={(v) => handleTierChange('bronze', v)}
      />

      <TierEligibility
        tier="silver"
        value={value.silver || { eligible: true, slots: 0, description: '', descriptionJa: '' }}
        onChange={(v) => handleTierChange('silver', v)}
      />

      <TierEligibility
        tier="gold"
        value={value.gold || { eligible: true, slots: 0, description: '', descriptionJa: '' }}
        onChange={(v) => handleTierChange('gold', v)}
      />
    </Col>
  );
};

export default EligibilitySection;
